// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"48":"metamask","167":"PageNotFound","375":"dati","966":"login"}[chunkId] + "." + {"48":"5e64c361","167":"afa624e3","375":"5c3d8299","966":"198df54f"}[chunkId] + ".css";
};